import { useEffect, useState } from "react";
import "./Home.css";
import About from "./About";
import BlogButton from "./BlogButton";
import { Preloader, Footer, Background, VideoUrl, ImageUrl, SocialLinks } from 'react-wavecoder-components';
import { useAnalytics } from "../hooks/useAnalytics";
import { useConfig } from "../hooks/useConfig";

const IMAGE_PATH_JPG = "/assets/background.jpg";
const IMAGE_PATH_WEBP = "/assets/background.webp";
const VIDEO_PATH_MP4 = "/assets/background.mp4";
const VIDEO_PATH_WEBM = "/assets/background.webm";

interface HomeProps {
  loaded: boolean;
  setLoaded: (loaded: boolean) => void;
}

const Home: React.FC<HomeProps> = ({ loaded, setLoaded }) => {
  const { config } = useConfig();
  const [preloadedImageUrls, setPreloadedImageUrls] = useState<ImageUrl>();
  const [videoUrl, setVideoUrl] = useState<VideoUrl>();

  useAnalytics();

  useEffect(() => {
    if (!config) {
      return;
    }
    const preloadJpg = preloadImage(new URL(IMAGE_PATH_JPG, config.api.cdnUrl).toString());
    const preloadWebp = preloadImage(new URL(IMAGE_PATH_WEBP, config.api.cdnUrl).toString());
    setVideoUrl({
      mp4: new URL(VIDEO_PATH_MP4, config.api.cdnUrl).toString(),
      webm: new URL(VIDEO_PATH_WEBM, config.api.cdnUrl).toString()
    } as VideoUrl);

    const minDelay = new Promise<void>((resolve) => setTimeout(resolve, 1000));
    Promise.all([preloadJpg, preloadWebp, minDelay]).then(([jpg, webp]) => {
      if (!jpg || !webp) {
        throw new Error("Failed to preload jpg or webp background image");
      }
      setPreloadedImageUrls({ jpg, webp });
      setLoaded(true);
    });
  }, [setLoaded, config]);

  return (
    <>
      <Preloader topLine="KAMIL" bottomLine="TAŁANDA" loaded={loaded} />
      {loaded && preloadedImageUrls && videoUrl && (preloadedImageUrls.jpg || preloadedImageUrls.webp) && (
        <Background
          imageUrl={preloadedImageUrls}
          videoUrl={videoUrl} />
      )}
      <div className="content-container">
        <About className="about" />
        <SocialLinks urls={[
          "https://github.com/ktalanda",
          "https://inthesunonthewave.blogspot.com",
          "https://www.instagram.com/wavecoder",
          "https://www.linkedin.com/in/kamil-tałanda-078a8225"
        ]} />
        <BlogButton className="blog" />
      </div>
      <div className="home-footer">
        <Footer name="Kamil Tałanda" />
      </div>
    </>
  );
}

const preloadImage = (src: string) =>
  new Promise<string | undefined>((resolve) => {
    const img = new window.Image();
    img.src = src.toString();
    img.onload = () => resolve(src);
    img.onerror = (error) => {
      console.error("Error preloading image:", error);
      resolve(undefined);}
  });

export default Home;
